module.exports = __webpack_public_path__ + "img/disperse_active.cb0e1a69.svg";